import { createRouter, createWebHistory } from 'vue-router'
import { consoleLog } from '@/utils/logger'
import { isScopedSession } from '@/utils/accountSwitch'
import UserLogin from '../components/Login.vue'
import UserRegister from '../components/Register.vue'
import Onboarding from '../components/Onboarding.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPassword from '../components/ResetPassword.vue'
import MainDashboard from '../components/Dashboard.vue'
import DashboardHome from '../views/DashboardHome.vue'
import DashboardAnalytics from '../views/DashboardAnalytics.vue'
import DashboardSettings from '../views/DashboardSettings.vue'
import ChatbotSettings from '../components/ChatbotSettings.vue'
import CreateChatbot from '../views/CreateChatbot.vue'
import ChatbotHomePage from '../views/ChatbotHomePage.vue'
import ChatbotList from '../components/ChatbotList.vue'
import AppHub from '../views/AppHub.vue'
import AllUsersPage from '../views/AllUsersPage.vue'
import ListUsers from '../views/ListUsers.vue' // New debug view
import WhatsAppManagement from '../views/WhatsAppManagement.vue'
import WhatsAppSignup from '../views/WhatsAppSignup.vue'
import PlaygroundView from '@/views/PlaygroundView.vue'
import ProfileView from '@/views/ProfileView.vue'
import AccountSettingsView from '@/views/AccountSettingsView.vue'
import FlowElementTest from '@/views/FlowElementTest.vue'
import JarvisKnowledgeView from '@/views/JarvisKnowledgeView.vue'
import VariablesView from '@/views/VariablesView.vue'
import AdminDashboard from '@/views/AdminDashboard.vue'
import ApiLogsView from '@/views/ApiLogsView.vue'
import GriotBuilderView from '@/views/GriotBuilderView.vue'

// Create a dummy dashboard component for now


const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'UserRegister',
    component: UserRegister
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding,
    meta: { requiresAuth: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/flow-element-test',
    name: 'FlowElementTest',
    component: FlowElementTest,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard/chatbots/:idchatbot/griot-builder',
    name: 'GriotBuilderView',
    component: GriotBuilderView,
    meta: { requiresAuth: true }
  },
  {
    path: '/agentbuilder/:idchatbot',
    name: 'AgentBuilder',
    component: () => import('@/views/AgentBuilder.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'MainDashboard',
    component: MainDashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: AppHub
      },
      {
        path: 'chatbots',
        name: 'ChatbotList',
        component: ChatbotList
      },
      {
        path: 'analytics',
        name: 'DashboardAnalytics',
        component: DashboardAnalytics
      },
      {
        path: 'settings',
        name: 'DashboardSettings',
        component: DashboardSettings
      },
      {
        path: 'chatbots/create',
        name: 'CreateChatbot',
        component: CreateChatbot
      },
      {
        path: 'chatbots/:id/settings',
        name: 'ChatbotSettings',
        component: ChatbotSettings
      },
      {
        path: 'chatbots/:id/home',
        name: 'ChatbotHomePage',
        component: ChatbotHomePage
      },
      {
        path: 'chatbots/:id/list-users',
        name: 'ListUsers',
        component: ListUsers
      },
      {
        path: 'all-users',
        name: 'AllUsersPage',
        component: AllUsersPage
      },
      {
        path: 'whatsapp_management',
        name: 'WhatsAppManagement',
        component: WhatsAppManagement
      },

      {
        path: 'whatsapp-signup/:idchatbot?',
        name: 'WhatsAppSignup',
        component: WhatsAppSignup,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'instagram',
        name: 'InstagramAutomations',
        component: () => import('@/views/InstagramAutomationsView.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'chatbots/:idchatbot/instagram',
        redirect: '/dashboard/instagram'
      },
      {
        path: 'whatsapp/broadcast',
        name: 'WhatsAppBroadcast',
        component: () => import('@/views/WhatsAppBroadcast.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'whatsapp/logs/:idwhatsapp',

        name: 'ApiLogsView',
        component: ApiLogsView,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'chat/:chatbotId',
        name: 'Chat',
        component: () => import('@/views/ChatPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Chat'
        }
      },
      {
        path: 'chat/:chatbotid/test',
        name: 'ChatTestPage',
        component: () => import('@/views/ChatTestPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'chat/:chatbotId/:usertel',
        name: 'ChatWithUser',
        component: () => import('@/views/ChatPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Chat'
        }
      },
      {
        path: 'chatbots/:idchatbot/playground',
        name: 'playground',
        component: PlaygroundView,
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/variables',
        name: 'ChatbotVariables',
        component: VariablesView,
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/playground/:idblock',
        name: 'playgroundWithBlock',
        component: PlaygroundView,
        meta: { requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'ProfileView',
        component: ProfileView,
        meta: { requiresAuth: true }
      },
      {
        path: 'account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: { requiresAuth: true }
      },
      {
        path: 'team',
        name: 'TeamView',
        component: () => import('@/views/TeamView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/jarvis-knowledge',
        name: 'JarvisKnowledgeView',
        component: JarvisKnowledgeView,
        meta: { requiresAuth: true }
      },

      {
        path: 'admin',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { 
          requiresAuth: true,
          requiresAdminEmail: true 
        }
      },
      {
        // Jauge du crédit Google pour la voix wolof (transcription et synthèse).
        // Réservée au compte superadmin, comme le panneau d'administration.
        path: 'voix-wolof',
        name: 'VoixWolofView',
        component: () => import('@/views/VoixWolofView.vue'),
        meta: { requiresAuth: true, requiresAdminEmail: true }
      },
      {
        path: 'chatbots/:idchatbot/integration/widget',
        name: 'WidgetIntegrationView',
        component: () => import('@/views/WidgetIntegrationView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/integration/widget',
        name: 'WidgetIntegrationStandalone',
        component: () => import('@/views/WidgetIntegrationView.vue'),
        meta: { requiresAuth: true }
      },
      // Routes temporaires pour éviter les erreurs de routing
      {
        path: 'transactions',
        name: 'Transactions',
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders',
        name: 'Orders', 
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'payouts',
        name: 'Payouts',
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'upgrade',
        name: 'UpgradePage',
        component: () => import('@/views/UpgradePage.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  // Routes pour l'intégration WhatsApp Shop (niveau racine - layout indépendant)
  {
    path: '/dashboard/:idchatbot/integration/whatsapp/shop/:token',
    name: 'WhatsAppShopIntegration',
    component: () => import('@/views/WhatsAppShopIntegration.vue'),
    meta: { requiresAuth: false } // Pas d'auth car l'utilisateur sera connecté via le token
  },
  {
    path: '/dashboard/:idchatbot/integration/whatsapp/shop',
    name: 'WhatsAppShopConfig',
    component: () => import('@/views/WhatsAppShopConfig.vue'),
    meta: { requiresAuth: true }
  },
  // Route pour la connexion automatique admin
  {
    path: '/dashboard/auto-login/:token',
    name: 'AutoLogin',
    component: () => import('@/views/AutoLoginView.vue'),
    meta: { requiresAuth: false }
  },
  // Acceptation d'une invitation à un compte partagé (plein écran, hors layout dashboard).
  {
    path: '/dashboard/team/accept/:token',
    name: 'AcceptInvite',
    component: () => import('@/views/AcceptInviteView.vue'),
    meta: { requiresAuth: false }
  },
  // Route pour le debug du token d'authentification
  {
    path: '/debug/token-auth/:idchatbot?',
    name: 'TokenAuthDebug',
    component: () => import('@/views/TokenAuthDebug.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  console.log(`🛣️ Router Trace: ${from.path} -> ${to.path}`);
  const isAuthenticated = localStorage.getItem('user') !== null
  const user = isAuthenticated ? JSON.parse(localStorage.getItem('user')) : null

  // Invitation à un compte partagé en attente : juste après une connexion / inscription,
  // on renvoie l'utilisateur vers la page d'acceptation plutôt que vers le dashboard.
  const pendingInvite = localStorage.getItem('peelo_pending_invite')
  if (isAuthenticated && pendingInvite &&
      (to.path === '/dashboard' || to.path === '/dashboard/') &&
      ['/login', '/register', '/onboarding'].includes(from.path)) {
    return next(`/dashboard/team/accept/${pendingInvite}`)
  }

  // Session partagée LIMITÉE à des agents : liste blanche de pages. Tout le reste
  // du dashboard (hub admin, analytics, réglages, abonnés…) redirige vers la liste
  // d'agents — le serveur bloque déjà les endpoints, ici on évite les pages mortes.
  if (isAuthenticated && isScopedSession() && to.path.startsWith('/dashboard')) {
    const allowed = (to.path.startsWith('/dashboard/chatbots') && to.path !== '/dashboard/chatbots/create')
      || to.path.startsWith('/dashboard/team');
    if (!allowed) return next('/dashboard/chatbots')
  }

  // FORCER l'onboarding tant que l'inscription n'est pas finalisée : un utilisateur
  // connecté avec registration_incomplete=true ne peut accéder à rien d'autre que /onboarding.
  const regIncomplete = !!(user && (user.data ? user.data.registration_incomplete : user.registration_incomplete))
  if (isAuthenticated && regIncomplete && to.path !== '/onboarding' && to.path !== '/login') {
    console.log("📝 Inscription incomplète -> redirection forcée vers /onboarding")
    return next('/onboarding')
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      console.log("⛔ Not authenticated, redirecting to /login");
      next('/login')
    } else if (to.matched.some(record => record.meta.requiresAdminEmail)) {
      // Vérifier si l'utilisateur a l'email admin requis
      const userEmail = user?.data?.email || user?.email;
      if (userEmail === 'mamadou.dieye@peelo.chat') {
        next()
      } else {
        // Rediriger vers le dashboard principal si pas admin
        consoleLog('Accès admin refusé pour:', userEmail);
        next('/dashboard')
      }
    } else {
      next()
    }
  } else if (to.path === '/login' && isAuthenticated) {
    console.log("✅ Authenticated, redirecting to /dashboard");
    next('/dashboard')
  } else {
    next()
  }
})

export default router 